import { Box, Typography } from '@mui/material';
import { AccountCircle } from '@mui/icons-material';
import { GroupMessageSmsPreviewTime } from './groupMessageSmsPreviewTime';

type GroupMessageSmsPreviewStatusBarProps = {
  sender: string;
};

export const GroupMessageSmsPreviewStatusBar = (props: GroupMessageSmsPreviewStatusBarProps) => {
  const { sender } = props;
  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          flexFlow: 'row',
          alignItems: 'center',
          height: '18px',
          padding: '0 5.4px',
          fontSize: '11px',
        }}
      >
        <Box
          className='signal'
          sx={{
            display: 'flex',
            flexFlow: 'row',
            alignItems: 'center',
            '& .dot': {
              boxShadow: 'inset 0 0 1px 0 #000',
              width: '6px',
              height: '6px',
              borderRadius: '6px',
              '&:not(:last-child)': {
                marginRight: '2px',
              },
              '&.filled': {
                background: '#000',
              },
            },
          }}
        >
          <Box className='dot filled' />
          <Box className='dot filled' />
          <Box className='dot filled' />
          <Box className='dot' />
          <Box className='dot' />
        </Box>
        <Box
          className='carrier'
          sx={{
            margin: '0 5.4px',
            flex: '0 0 40.5px',
            maxWidth: '40.5px',
          }}
        >
          Telia 4G
        </Box>
        <div className='connection'>
          <div className='wifi' />
        </div>
        <Box
          className='time'
          sx={{
            width: '50%',
            textAlign: 'center',
            flex: '0 0 auto',
          }}
        >
          <GroupMessageSmsPreviewTime />
        </Box>
        <Box
          className='icons'
          sx={{
            flex: '1 1 auto',
            display: 'flex',
            flexFlow: 'row',
            justifyContent: 'flex-end',
            alignItems: 'center',
            alignSelf: 'stretch',
            '.battery': {
              height: '9px',
              width: '20.25px',
              border: '1px solid #000',
              borderRadius: '2px',
              position: 'relative',
              marginRight: '3.375px',
              '&:before': {
                content: '""',
                position: 'absolute',
                background: '#000',
                left: '100%',
                marginLeft: '1px',
                top: '50%',
                marginTop: '-2.5px',
                borderRadius: '2px',
                width: '2px',
                height: '5px',
              },
              '&:after': {
                content: '""',
                position: 'absolute',
                top: '1px',
                left: '1px',
                bottom: '1px',
                width: '75%',
                background: '#000',
              },
            },
          }}
        >
          <Box className='battery' />
        </Box>
      </Box>
      <Box sx={{ textAlign: 'center', p: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <AccountCircle fontSize='large' sx={{ color: (thm) => thm.palette.grey[600] }} />
        <Typography sx={{ fontWeight: 500 }}>{sender}</Typography>
      </Box>
    </Box>
  );
};
